import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const BatteryEmptyIcon = ({ size, className, ...other }) => (
  /* eslint-disable */

  <div
    className={clsx(
      "em-c-icon",
      {
        "em-c-icon--small": size === "small",
        "em-c-icon--medium": size !== "small" && size !== "large",
        "em-c-icon--large": size === "large"
      },
      "em-icon-wrapper",
      className
    )}
    {...other}
  >
    {size === "small" ? (
      <svg height="100%" width="100%" viewBox="0 0 16 16">
        <path
          d="M12.5 14h-11A1.5 1.5 0 0 1 0 12.5v-7A1.5 1.5 0 0 1 1.5 4h11A1.5 1.5 0 0 1 14 5.5v7a1.5 1.5 0 0 1-1.5 1.5zm-11-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5zM15.5 12H14v-1h1V7h-1V6h1.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5z"
          fill="currentColor"
        />
      </svg>
    ) : size === "large" ? (
      <svg height="100%" width="100%" viewBox="0 0 48 48">
        <path
          d="M39 38H3a3 3 0 0 1-3-3V13a3 3 0 0 1 3-3h36a3 3 0 0 1 3 3v22a3 3 0 0 1-3 3zM3 12a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1V13a1 1 0 0 0-1-1zM46 32h-2v-2h2V18h-2v-2h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2z"
          fill="currentColor"
        />
      </svg>
    ) : (
      <svg height="100%" width="100%" viewBox="0 0 24 24">
        <path
          d="M19 20H2a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h17a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2zM2 7v11h17V7zM23 17h-2v-2h1v-5h-1V8h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1z"
          fill="currentColor"
        />
      </svg>
    )}
  </div>

  /* eslint-enable */
);

BatteryEmptyIcon.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]),

  /** className allows you to append css classes */

  className: PropTypes.string
};

BatteryEmptyIcon.defaultProps = {
  size: "medium",

  className: ""
};

export default BatteryEmptyIcon;
